import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  CloneBoundaryTerritoryGroupModal, type CloneBoundaryTerritoryGroupModalProps,
} from './cloneBoundaryTerritoryGroupModal';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    CloneBoundaryTerritoryGroup: CloneBoundaryTerritoryGroupModalProps;
  }
}
modalRenderer.register('CloneBoundaryTerritoryGroup', CloneBoundaryTerritoryGroupModal);
